/* The error boundary's screen. It replaces the whole shell, so it has to stand on its own: a
   centred panel, the failure's sentence at reading size and one way out. Tokens only (ADR-0007). */

.main {
  box-sizing: border-box;
  height: 100%;
  padding: 48px 24px;
  overflow: auto;
  background: var(--bg);
}

.card {
  max-width: 560px;
  margin: 0 auto;
  padding: 20px 22px;
  background: var(--panel);
  border: 1px solid var(--line);
  border-left: 3px solid var(--crit);
  border-radius: var(--radius);
}

.title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 6px;
  font-size: var(--t-head);
  font-weight: 650;
  color: var(--ink);
}

/* Filled, so the failure is told by shape as well as by the red rule on the card's edge. */
.icon {
  flex-shrink: 0;
  color: var(--crit);
}

.body {
  max-width: 72ch;
  margin: 0 0 14px;
  font-size: var(--t-dense);
  line-height: 1.55;
  color: var(--ink-2);
}

.retry {
  height: 32px;
  padding: 0 14px;
  font-size: var(--t-dense);
  font-weight: 600;
  color: var(--on-fill);
  background: var(--accent);
  border: 1px solid var(--accent);
  border-radius: var(--radius-ctl);
  cursor: pointer;
  transition: background-color var(--dur-1) var(--ease-std);
}

.retry:hover {
  background: var(--accent-h);
  border-color: var(--accent-h);
}

.retry:active {
  background: var(--ink);
  border-color: var(--ink);
}

.retry:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}
